import * as ReactPDF from 'react-pdf';
import { usePrintNuvemEnvioLabelToast } from 'domains/NuvemEnvioCommons/Orders/hooks/usePrintNuvemEnvioLabelToast';
import 'domains/NuvemEnvioCommons/Orders/utils/print-pdf.scss';
import { NE_LABEL_WIDTH } from 'domains/NuvemEnvioCommons/Orders/utils/print-ne-label-configs';

interface PdfPageProps {
  url: string;
}

function PdfPage({ url }: Readonly<PdfPageProps>) {
  const { addErrorToast } = usePrintNuvemEnvioLabelToast();
  const onPdfRenderSuccess = () => {
    globalThis.print();
  };

  const onPdfRenderError = () => {
    addErrorToast();
  };

  return (
    <div className="pdf-print">
      <ReactPDF.Document file={url}>
        <ReactPDF.Page
          pageNumber={1}
          scale={1}
          renderAnnotationLayer={false}
          renderTextLayer={false}
          onRenderSuccess={onPdfRenderSuccess}
          onRenderError={onPdfRenderError}
          width={NE_LABEL_WIDTH}
        />
      </ReactPDF.Document>
    </div>
  );
}

export default PdfPage;
